
import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import { postData } from "../../../../../ApiServices/ApiService";
import { logFrontendException } from "../../../../../Utils/Exception";
import { ORG_CONFIGURATION_CONFIG_CENTER } from "../../../../../ApiServices/BaseURL";
import { validateEmail } from "../../../../../Utils/Validation";
import { useTheme } from "../../../../../GlobalContext/GlobalContext";

const EmailConfigurationController = (data, loading, error, onRefresh) => {
    const [senderEmail, setSenderEmail] = useState('');
    const [senderName, setSenderName] = useState('');

    const [saveLoading, setSaveLoading] = useState(false);
    const [saveError, setSaveError] = useState('');
    const [success, setSuccess] = useState('');

    const [senderEmailError, setSenderEmailError] = useState('');

    const navigator = useNavigate();

    const { setIsLoginPopup } = useTheme();

    const pageName = "EmailConfigurationController";

    useEffect(() => {
        if (data) {
            setSenderEmail(data?.sender_email_id || '');
            setSenderName(data?.sender_name || '');
        }
        setSaveError(error);
        setSaveLoading(loading);
    }, [data, error, loading]);

    const saveEmailConfig = async () => {
        setSaveLoading(true);
        setSaveError('');
        setSuccess('');
        setSenderEmailError('');

        const storedUser = JSON.parse(localStorage.getItem("_userInfo_"));

        // Validate required fields
        if (!senderEmail.trim()) {
            setSenderEmailError("Sender Email is required.");
            setSaveLoading(false);
            return;
        }

        if (!validateEmail(senderEmail)) {
            setSenderEmailError('Invalid email address.');
            setSaveLoading(false);
            return;
        }

        const payload = {
            op: 'email',
            action_type: data ? "update_email_config" : "add_email_config",
            emp_id_auth: storedUser?.emp_id,
            sender_name: senderName,
            sender_email_id: senderEmail,
        };

        console.log("peyload", payload)

        try {
            const response = await postData(ORG_CONFIGURATION_CONFIG_CENTER, payload);
            const responseData = await response.json();

            if (response?.status === 200) {
                if (responseData?.statusCode === 200) {
                    if (responseData?.message?.toLowerCase() === "success") {
                        setSuccess(responseData?.info);
                        setTimeout(() => {
                            onRefresh();
                            setSuccess('');
                        }, 3000);
                    } else {
                        setSaveError(responseData?.info || "Failed to add/update Email configuration.");
                        logFrontendException(storedUser?.emp_id, pageName, "saveEmailConfig", responseData?.info);
                    }
                } else {
                    setSaveError(responseData?.info || "Unable to add/update Email configuration.Please try again.");
                    logFrontendException(storedUser?.emp_id, pageName, "saveEmailConfig", responseData);
                }
            } else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                setSaveError('Unauthorized access. Your session may have expired. Please log in again.');
                setIsLoginPopup(true)
                logFrontendException(storedUser?.emp_id, pageName, 'saveEmailConfig-Unauthorized', response || '');
            } else {
                setSaveError("Failed to add/update Email configuration.Please try again.");
                logFrontendException(storedUser?.emp_id, pageName, "saveEmailConfig", responseData);
            }
        } catch (error) {
            setSaveError("Failed to add/update Email configuration.Please Check your internet connection and try again.");
            logFrontendException(storedUser?.emp_id, pageName, "saveEmailConfig-catch", error);
        } finally {
            setSaveLoading(false);
        }
    };

    const handleCancel = () => {
        navigator('/dashboard');
    }

    return {
        senderEmail,
        setSenderEmail,
        senderName,
        setSenderName,
        saveLoading,
        saveError,
        success,
        saveEmailConfig,
        senderEmailError,
        setSenderEmailError,
        handleCancel,
    }
}
export default EmailConfigurationController;